import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { sources: Object };

  connect() {
    this.connected = true;
    this.schedule = () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.upgrade(), 0);
    };
    this.observer = new MutationObserver(this.schedule);
    this.observer.observe(this.element, { attributes: true, attributeFilter: ['src'] });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.schedule, { once: true });
    } else {
      this.schedule();
    }
  }

  disconnect() {
    this.connected = false;
    clearTimeout(this.timer);
    document.removeEventListener('DOMContentLoaded', this.schedule);
    this.observer.disconnect();
    this.cancelPending();
  }

  sourcesValueChanged() {
    this.schedule?.();
  }

  cancelPending() {
    this.pending?.removeAttribute('src');
    this.pending = null;
  }

  async upgrade() {
    if (!this.connected || document.readyState === 'loading') return;
    const preview = this.element.getAttribute('src');
    const original = this.sourcesValue[preview];
    this.cancelPending();
    if (!original || original === preview) return;

    const image = new Image();
    this.pending = image;
    image.src = original;
    try {
      await image.decode();
      if (this.connected && this.pending === image &&
          this.element.getAttribute('src') === preview && this.sourcesValue[preview] === original) {
        this.element.setAttribute('src', original);
      }
    } catch {
      // Keep the usable preview if downloading or decoding the original fails.
    } finally {
      if (this.pending === image) this.pending = null;
    }
  }
}
